export { default } from './CompanyImageBlock';
